import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const delisting: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'delistExch' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [{ type: 'field', field: 'delistReason' }],
    },
];

export default delisting;
